<template>
  <div>
    <u-loader v-if="isLoading" />
    <div v-else>
      <div
        v-for="(content, i) in contents"
        :key="i"
        class="pt-2 mt-2 pl-4 pr-4 pb-5"
      >
        <div v-if="content.language === 'de-CH'">
          <h4>Deutsch</h4>
          <hr>
          <div v-if="canUserEdit">
            <tiny-mce-editor
              v-if="content.text"
              v-model="content.text"
            />
            <tiny-mce-editor
              v-else
              v-model="content.value"
            />
          </div>
          <div
            v-else
            v-html="content.text || content.value"
          />
        </div>

        <div v-else-if="content.language === 'fr-CH'">
          <h4>Französisch</h4>
          <hr>
          <div v-if="canUserEdit">
            <tiny-mce-editor
              v-if="content.text"
              v-model="content.text"
            />
            <tiny-mce-editor
              v-else
              v-model="content.value"
            />
          </div>
          <div
            v-else
            v-html="content.text || content.value"
          />
        </div>

        <div v-else-if="content.language === 'it-CH'">
          <h4>Italienisch</h4>
          <hr>
          <div v-if="canUserEdit">
            <tiny-mce-editor
              v-if="content.text"
              v-model="content.text"
            />
            <tiny-mce-editor
              v-else
              v-model="content.value"
            />
          </div>
          <div
            v-else
            v-html="content.text || content.value"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TinyMceEditor from "@/components/common/tinyMceEditor.vue";
import ULoader from "@/components/common/ULoader.vue";

export default {
  components: {
    TinyMceEditor,
    ULoader,
  },
  props: {
    canUserEdit: {
      type: Boolean,
      default: false,
    },
    contents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    this.isLoading = true;
    this.contents.forEach((content) => {
      if (!("value" in content)) {
        this.$set(content, "value", " ");
      }
      if (!("text" in content)) {
        this.$set(content, "text", " ");
      }
      content.customId = this.getRandomId() + "_" + content.language;
    });
    this.isLoading = false;
  },
  methods: {
    getRandomId() {
      return (Math.random() + 1).toString(36).substring(7);
    },
    updateValidation() {
      this.$emit("updateValidation");
    },
  },
};
</script>

<style scoped>
.pt-2 {
  padding-top: 0.5rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.pl-4 {
  padding-left: 1.5rem;
}

.pr-4 {
  padding-right: 1.5rem;
}

.pb-5 {
  padding-bottom: 3rem;
}
</style>
